<input matInput #multiSelectSearch class="search" (keyup)="onKey($event.target.value)" [placeholder]="placeHolder">